export const navigateAwayMessage =
  "You haven't saved yet and will lose your changes.";
